/**
 * WeaponSword — straight one-handed sword.
 * Renders as an SVG <g> group in the knight's coordinate space (25×25).
 * Blade points upward (y decreasing), guard at y≈11, handle below.
 */
export default function WeaponSword() {
  return (
    <g>
      {/* Blade */}
      <rect x="21"   y="0.5" width="2"   height="11"  rx="0.6" fill="#c0d8f0"/>
      {/* Edge highlight */}
      <rect x="21.2" y="0.5" width="0.6" height="10"  rx="0.3" fill="#e8f4ff" opacity="0.6"/>
      {/* Cross-guard */}
      <rect x="18.5" y="11"  width="7"   height="1.5" rx="0.5" fill="#9ab0c8"/>
      {/* Handle / grip */}
      <rect x="21.5" y="12"  width="1.5" height="4"   rx="0.5" fill="#7a6a5a"/>
      {/* Pommel */}
      <circle cx="22.25" cy="16.5" r="1.2" fill="#6a5a48" stroke="#9ab0c8" strokeWidth="0.5"/>
    </g>
  );
}
